var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#26a69a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33692 9H6.80292C8.08092 9 8.84592 8.316 8.84592 7.164C8.84592 6.381 8.49492 5.859 7.81992 5.616C8.26092 5.364 8.51292 4.896 8.51292 4.311C8.51292 3.321 7.77492 2.727 6.52392 2.727H4.33692V9ZM5.46192 5.22V3.762H6.52392C7.07292 3.762 7.38792 4.032 7.38792 4.509C7.38792 4.977 7.09092 5.22 6.52392 5.22H5.46192ZM5.46192 7.965V6.255H6.71292C7.36992 6.255 7.72092 6.543 7.72092 7.074C7.72092 7.623 7.34292 7.965 6.71292 7.965H5.46192Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/Buy.5865e40712d95dd4f8deed96d221b897.svg";
export { ForwardRef as ReactComponent };